type FetchErrorProps = {
  error: string | undefined;
};
const FetchError = ({ error }: FetchErrorProps) => {
  return (
    <div className="text-danger font-bold text-center text-sm py-4">
      Error! {error}
    </div>
  );
};

export default FetchError;
